// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___2C1xd","instructions":"styles-module__instructions___3Qxqd","subtext":"styles-module__subtext___13rrI"};